import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import useConsultantAuthStore from "../../store/consultant/useConsultantAuthStore";
import toast from "react-hot-toast";
import { AiOutlineLoading3Quarters } from "react-icons/ai";

const ForgotPassword = () => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email) {
      toast.error("Please enter your email address.");
      return;
    }
    if (!/\S+@\S+\.\S+/.test(email)) {
      toast.error("Please enter a valid email address.");
      return;
    }

    setLoading(true);
    setMessage("");
    try {
      // Call API to send reset email
      const { axiosInstancev1 } = await import("../../lib/axiosInstance");
      const response = await axiosInstancev1.post('/consultant/forgot-password', { email });
      
      if (response.data.success) {
        setMessage("Please check your email for the password reset link.");
        setEmail("");
        toast.success("Reset email sent successfully!");
      } else {
        toast.error(response.data.message || "Failed to send reset email");
      }
    } catch (error) {
      console.error("Forgot password request failed:", error);
      toast.error(error.response?.data?.message || "Failed to send reset email. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      className="min-h-screen flex items-center justify-center p-4 relative"
      style={{
        backgroundImage: "url('/assets/CustomerBg.jpg')",
        backgroundSize: 'cover',
        backgroundPosition: 'center',
      }}
    >
      <div className="absolute inset-0 bg-black opacity-50 z-0"></div>
      <div className="w-full max-w-md p-8 bg-white/90 backdrop-blur-md rounded-2xl shadow-2xl border border-gray-200 relative z-10">
        <h2 className="text-2xl font-bold text-center text-gray-800 mb-4">
          Forgot Password
        </h2>
        <p className="text-center text-gray-600 text-sm mb-6">
          Enter your consultant account email address and we'll send you a link to reset your password.
        </p>

        {message && (
          <div className="mb-4 p-3 bg-green-100 text-green-700 text-sm rounded-lg text-center">
            {message}
          </div>
        )}

        {!message && (
          <form onSubmit={handleSubmit}>
            <div className="mb-5">
              <label
                htmlFor="email"
                className="block text-sm font-medium text-gray-700 mb-1"
              >
                Email Address
              </label>
              <input
                type="email"
                id="email"
                name="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="w-full px-4 py-2.5 border border-gray-300 rounded-xl bg-gray-100 focus:outline-none focus:ring-2 focus:ring-blue-400"
                placeholder="Enter your registered email"
                required
                disabled={loading}
              />
            </div>

            <div className="flex flex-col items-center">
              <button
                type="submit"
                disabled={loading}
                className={`w-full px-6 py-2.5 text-white transition-all duration-300 flex items-center justify-center rounded-xl font-semibold ${loading ? "opacity-70 cursor-not-allowed bg-blue-400" : "bg-blue-600 hover:bg-blue-700"}`}
              >
                {loading ? (
                  <>
                    <AiOutlineLoading3Quarters className="animate-spin mr-2" />
                    Sending...
                  </>
                ) : (
                  "Send Reset Link"
                )}
              </button>

              <button
                type="button"
                onClick={() => navigate("/consultant/login")}
                className="mt-4 text-sm text-blue-600 hover:underline font-medium"
                disabled={loading}
              >
                Back to Login
              </button>
            </div>
          </form>
        )}

        {message && (
          <div className="flex justify-center mt-4">
            <button
              type="button"
              onClick={() => navigate("/consultant/login")}
              className="text-sm text-blue-600 hover:underline font-medium"
            >
              Back to Login
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default ForgotPassword;
